module.exports = __webpack_public_path__ + "img/12_Q_diamonds_star.d1132bb9.png";